import React from 'react';
import BankContract from '@src/pages/ticketShared/BankContract';

const Wrapper = () => <BankContract containerClass="bank-contract" />;

export default Wrapper;
